import type {
  CreateTagRequest,
  CreateTagResponse,
  CreateTraditionalExerciseRequest,
  CreateWorkoutRequest,
  DeleteExerciseResponse,
  DeleteTagResponse,
  DeleteWorkoutResponse,
  GetWorkoutResponse,
  ListExercisesResponse,
  ListTagsResponse,
  ListWorkoutsResponse,
  UpdateExerciseResponse,
  UpdateTagRequest,
  UpdateTagResponse,
  UpdateTraditionalExerciseRequest,
  UpdateWorkoutRequest,
  UpdateWorkoutResponse,
  CreateExerciseResponse,
  CreateWorkoutResponse,
  GenerateFileUploadUrlRequest,
  GenerateFileUploadUrlResponse,
} from "types/traditionalWorkouts";
import config from "../config/config";
import axios from "../util/axios";

const baseUrl = `${config.defaults.api_url}/traditional-workouts`;

export async function createTraditionalExercise(
  payload: CreateTraditionalExerciseRequest,
): Promise<CreateExerciseResponse> {
  const response = await axios.post<CreateExerciseResponse>(
    `${baseUrl}/exercises`,
    payload,
  );
  return response.data;
}

export async function listTraditionalExercises(): Promise<ListExercisesResponse> {
  const response = await axios.get<ListExercisesResponse>(
    `${baseUrl}/exercises`,
  );
  return response.data;
}

export async function updateTraditionalExercise(
  exerciseId: string,
  payload: UpdateTraditionalExerciseRequest,
): Promise<UpdateExerciseResponse> {
  const response = await axios.patch<UpdateExerciseResponse>(
    `${baseUrl}/exercises/${exerciseId}`,
    payload,
  );
  return response.data;
}

export async function deleteTraditionalExercise(
  exerciseId: string,
): Promise<DeleteExerciseResponse> {
  const response = await axios.delete<DeleteExerciseResponse>(
    `${baseUrl}/exercises/${exerciseId}`,
  );
  return response.data;
}

export async function createWorkoutTag(
  payload: CreateTagRequest,
): Promise<CreateTagResponse> {
  const response = await axios.post<CreateTagResponse>(
    `${baseUrl}/tags`,
    payload,
  );
  return response.data;
}

export async function listWorkoutTags(): Promise<ListTagsResponse> {
  const response = await axios.get<ListTagsResponse>(`${baseUrl}/tags`);
  return response.data;
}

export async function updateWorkoutTag(
  tagId: string,
  payload: UpdateTagRequest,
): Promise<UpdateTagResponse> {
  const response = await axios.patch<UpdateTagResponse>(
    `${baseUrl}/tags/${tagId}`,
    payload,
  );
  return response.data;
}

export async function deleteWorkoutTag(
  tagId: string,
): Promise<DeleteTagResponse> {
  const response = await axios.delete<DeleteTagResponse>(
    `${baseUrl}/tags/${tagId}`,
  );
  return response.data;
}

export async function createTraditionalWorkout(
  payload: CreateWorkoutRequest,
): Promise<CreateWorkoutResponse> {
  const response = await axios.post<CreateWorkoutResponse>(
    `${baseUrl}`,
    payload,
  );
  return response.data;
}

export async function listTraditionalWorkouts(): Promise<ListWorkoutsResponse> {
  const response = await axios.get<ListWorkoutsResponse>(`${baseUrl}`);
  return response.data;
}

export async function getTraditionalWorkout(
  workoutId: string,
): Promise<GetWorkoutResponse> {
  const response = await axios.get<GetWorkoutResponse>(
    `${baseUrl}/${workoutId}`,
  );
  return response.data;
}

export async function updateTraditionalWorkout(
  workoutId: string,
  payload: UpdateWorkoutRequest,
): Promise<UpdateWorkoutResponse> {
  const response = await axios.patch<UpdateWorkoutResponse>(
    `${baseUrl}/${workoutId}`,
    payload,
  );
  return response.data;
}

export async function deleteTraditionalWorkout(
  workoutId: string,
): Promise<DeleteWorkoutResponse> {
  const response = await axios.delete<DeleteWorkoutResponse>(
    `${baseUrl}/${workoutId}`,
  );
  return response.data;
}

export async function generateFileUploadUrl(
  payload: GenerateFileUploadUrlRequest,
): Promise<GenerateFileUploadUrlResponse> {
  const response = await axios.post<GenerateFileUploadUrlResponse>(
    `${baseUrl}/generate-file-upload-url`,
    payload,
  );
  return response.data;
}
